export default {
	sec_01: {
		title: {
			one: '良く行くお店でお支払いしてください。',
			two: 'を使って、',
			three: 'JP WOLRD Pay',
		},
		desc: {
			one: '対面での決済は、お支払い時にQRコードを',
			two: 'スキャンするのと同じくらい簡単で、タッチが不要です。',
			three: 'クレジットカードや現金は不要で、アプリを使うだけです。',
		},
		btn: {
			one: '会員登録',
			two: 'ログイン',
		},
	},
	sec_04: {
		title: '未来の貨幣システムへようこそ。',
		cards: {
			one: {
				title: '安全な決済',
				description: {
					one: 'オフライン決済時にお客様のデー',
					two: 'タは残りません。',
				},
			},
			two: {
				title: 'お近くの加盟店で',
				description: {
					one: 'いつでも、どこでも、JP WOLRD Pay',
					two: '加盟店を検索してご利用ください。',
				},
			},
			three: {
				title: 'キャッシュレス',
				description: {
					one: 'まだ現金を持ち歩きますか?スマ',
					two: 'ホでJPWORLDPAYをすぐ使うことができます。',
				},
			},
		},
	},
	sec_06: {
		title: {
			one: 'QRで3段階決済',
			two: 'JP WOLRD Pay ',
			three: 'アプリとアカウントが必要です。',
		},
		step: {
			one: {
				title: 'STEP 01.',
				subTitle: 'スキャンもしくは表示',
				desc: {
					one: 'QRアイコンをタップして、販売加盟店がコードを提示した場合は スキャンを選択する。',
					two: 'またはQRコードを要求された場合は 「表示」を選択します。',
				},
			},
			two: {
				title: 'STEP 02.',
				subTitle: '支払い',
				desc: {
					one: 'QRコードが表示されたらコードをスキャン',
					two: '',
				},
			},
			three: {
				title: 'STEP 03.',
				subTitle: '確認',
				desc: {
					one: '決済確認を受信するとすべての決済が完了します。',
					two: '',
				},
			},
		},
	},
	sec_07: {
		title: {
			one: 'QRコードで',
			two: '販売する準備をしましょう。',
		},
		desc: {
			one: 'ビジネスを開始する場合、ハードウェア、ソフトウェア、',
			two: 'またはカードリーダーが無くても直接タッチする必要が無いので、',
			three: '対面決済を簡単に受け入れることができます。',
		},
	},
};
